module.exports = __webpack_public_path__ + "img/noHoliday.24fcda83.png";